module.exports = __webpack_public_path__ + "static/img/swipe-1-3.d9161a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/swipe-1-3.png
// module id = /bVh
// module chunks = 10